module.exports = __webpack_public_path__ + "img/图层 604@2x.eb0de082.png";